import { useContext, useEffect, useState } from 'react';
import { Timer } from '@fff-web/fff-utilities';
import GlobalNavContext from '../context/globalNavContext';
import {
  ACTIVE_CHECKOUT,
  PASSIVE_CHECKOUT,
  TIMER_COMPLETED,
  USER_COMPLETED,
} from '../helpers/constants/newMemberStates';
import { getTimer } from '../services';

export function useNmfTimer() {
  const globalNavContext = useContext(GlobalNavContext);
  const [timer, setTimer] = useState({
    endTime: null,
    userId: null,
    newMemberState: '',
    lastVisitedCustomizeQuestionId: null,
    timerType: 'NEW_MEMBER',
    timerSource: '',
  });
  useEffect(() => {
    (async () => {
      try {
        const res = await getTimer(globalNavContext.env);
        // If there is no timer or time is up redirect new member to homepage
        if (
          !res ||
          (res.endTime &&
            Timer.getTimeLeft(new Date(`${res.endTime}Z`)).timeUp) ||
          (res.newMemberState && res.newMemberState === USER_COMPLETED) ||
          (res.newMemberState && res.newMemberState === ACTIVE_CHECKOUT) ||
          (res.newMemberState && res.newMemberState === PASSIVE_CHECKOUT) ||
          (res.newMemberState && res.newMemberState === TIMER_COMPLETED)
        ) {
          if (
            window.location.href !== globalNavContext.env.REACT_APP_BASE_URL
          ) {
            window.location.href = globalNavContext.env.REACT_APP_BASE_URL;
          }
        }
        setTimer({
          endTime: res.endTime,
          userId: res.userId,
          newMemberState: res.newMemberState,
          lastVisitedCustomizeQuestionId: res.lastVisitedCustomizeQuestionId,
          timerType: res.timerType,
          timerSource: res.timerSource,
        });
      } catch (err) {
        console.error(err);
        setTimer(false);
      }
    })();
  }, [globalNavContext.env]);
  return timer;
}
